import talkieAvatar from './talkie-default.png';
import xingyeAvatar from './xingye-defaultAvatar.png';
import { isTalkie } from '../../utils';

export { default as book } from './book.svg';
export const defaultAvatar = isTalkie ? talkieAvatar : xingyeAvatar;

export { default as sideBarFMIcon } from './sideBarFMIcon.svg';
export { default as sideBarFMActiveIcon } from './sideBarFMActiveIcon.svg';
export { default as sideBarImageLibIcon } from './sideBarImageLibIcon.svg';
export { default as sideBarHomeIcon } from './sideBarHomeIcon.svg';
export { default as reedit } from './reedit.svg';
export { default as discord } from './discord.svg';
export { default as sideBarImageLibActiveIcon } from './sideBarImageLibActiveIcon.svg';
export { default as sideBarHomeActiveIcon } from './sideBarHomeActiveIcon.svg';
export { default as sideBarHomeUnActiveIcon } from './sideBarHomeUnActiveIcon.svg';
export { default as sideBarAgentIcon } from './sideBarAgentIcon.svg';
export { default as sideBarAgentActiveIcon } from './sideBarAgentActiveIcon.svg';
export { default as sideBarReplicateIcon } from './sideBarReplicateIcon.svg';
export { default as sideBarReplicateActiveIcon } from './sideBarReplicateActiveIcon.svg';
